<app-back-to-menu *ngIf="isNotHomepage" class="fixed"></app-back-to-menu>
<div class="header-image">
    <img class="header-image" src="../../../assets/images/header-image-oneline.png">
</div>
<router-outlet></router-outlet>